import { Bell, FileText, Mail, Settings2 } from 'lucide-react'

import type { NavItem } from '@/shared/layout/navigation'

export const notificationsNavigation: NavItem[] = [
  {
    to: '/notifications/push',
    labelKey: 'nav.push',
    group: 'nav.groups.communication',
    icon: Bell,
    permission: 'notifications.view',
  },
  {
    to: '/notifications/campaigns',
    labelKey: 'nav.campaigns',
    group: 'nav.groups.communication',
    icon: Mail,
    permission: 'notifications.view',
  },
  {
    to: '/notifications/templates',
    labelKey: 'nav.templates',
    group: 'nav.groups.communication',
    icon: FileText,
    permission: 'notifications.view',
  },
  {
    to: '/notifications/settings',
    labelKey: 'nav.notificationSettings',
    group: 'nav.groups.communication',
    icon: Settings2,
    permission: 'notifications.manage',
  },
]
